import { createFileRoute } from '@tanstack/react-router';
import { LunchBreakPage } from '@/features/settings/ui/LunchBreakPage';

export const Route = createFileRoute('/_authenticated/settings/lunch')({ component: LunchBreakPage });
